module.exports = __webpack_public_path__ + "static/media/Shilpa Mistry-McCallum Picture.27d34a84.jpg";